import { Component, Input } from '@angular/core';
import { ControlValueAccessor, UntypedFormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'pcm-data-form-field-combo-box',
	templateUrl: './data-form-field-combo-box.component.html',
	styleUrls: ['./data-form-field-combo-box.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		multi: true,
		useExisting: DataFormFieldComboBoxComponent
	}]
})
// uses ControlValueAccessor to wrap the Carbom component which uses a more complex data object that we don't need
export class DataFormFieldComboBoxComponent implements ControlValueAccessor {
	@Input() propName: string;
	@Input() name: string;
	@Input() formGroup: UntypedFormGroup;
	@Input() helpMessage: string;
	@Input() invalid = false;
	@Input() invalidText: string;
	@Input() required = false;
	@Input() type = 'single'; // 'single' or 'multi'
	@Input() placeholderText = 'Type to filter';
	@Input() options = [];

	value;
	onChange = (newValue) => {};
	onTouched = () => {};

	// carbon component returns a larger object, but just need the 'content' property in an array
	handleSelection(list): void {
		const internalList = list.map(x => x.content);
		this.value = internalList;
		this.onChange(internalList);
	};

	writeValue(value) {
		this.value = value !== undefined ? value : [];
	}
	registerOnChange(onChange: any) {
		this.onChange = onChange;
	}
	registerOnTouched(onTouched: any) {
		this.onTouched = onTouched;
	}
}
